import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { SalonMonsterTapRetryComponent } from './sm-tap-retry.component';

import { SharedModule } from '../../shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    SalonMonsterTapRetryComponent
  ],
  imports: [
    BrowserModule,
    MatIconModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
  ],
  exports: [
    SalonMonsterTapRetryComponent
  ],
  entryComponents: [],
  providers: []
})
export class SalonMonsterTapRetryModule {}
